export const en = {
    'error-401': 'No authorization to perform this operation',
    'error-429': 'Request limit exceeded. Try again later'
};
